// extracted by mini-css-extract-plugin
export var container = "_om-0";
export var dotAnimation = "_om-2";
export var dotsLoading = "_om-1";